import React, { useEffect, useState, useRef } from "react";
import {
  getAllRegistrationList,
  getAllRejectedList,
  getAllUpdatedList,
  getAllUserList,
} from "./utils";
import { getRakTransactionList } from "../reports/rak-transaction/utils";
import { getRechargeTransactionList } from "../reports/recharge-transaction/utils";
import {
  getManageUserList,
  getAuditTrailList,
  getBlockList,
} from "../settings/manageuserVerification/utils";
import moment from "moment";
import { CSVLink } from "react-csv";
import { getAllRakBeneficiaryList } from "../../service/rak-beneficiary-service";
import { getAllRechargeBeneficiaryList } from "../../service/recharge-beneficiary-service";
import { getProfilesList } from "../../pages/reports/utils";
import { getReferrerCodeList } from "../settings/manageuserVerification/utils";
import Loading from "../loader/loader";
import {
  notificationStrings,
  openNotificationWithIcon,
} from "../../common/notification-message/notification";
const MyCsvLink = ({ headers, filterdata, type, filename }) => {
  const csvLink = useRef();
  const [data, setdata] = useState([]);
  const [isFsttime, setIsfsttime] = useState(true);
  const [csvLoading, setCsvLoading] = useState(false);
  console.log("headers", headers);
  useEffect(() => {
    setIsfsttime(false);
    if (!isFsttime) {
      setTimeout(() => {
        csvLink.current.link.click();
      });
    }
  }, [data]);

  const fetchData = () => {
    //   let url = ;
    let req = { ...filterdata };
    req.page = "";
    req.size = "";

    if (req === "status") {
      req["status"] = req.status.length == 0 ? "" : req.status;
    } else if (req === "type") {
      req["type"] = req.type.length == 0 ? "" : req.type;
    } else if (req === "country") {
      req["country"] = req.country.length == 0 ? "" : req.country;
    }
    setCsvLoading(true);
    let url = "";
    if (type === "alluser") {
      url = getAllUserList;
    } else if (type === "registration") {
      url = getAllRegistrationList;
    } else if (type === "update") {
      url = getAllUpdatedList;
    } else if (type === "rejected") {
      url = getAllRejectedList;
    } else if (type === "rakbeneficiary") {
      url = getAllRakBeneficiaryList;
    } else if (type === "rechargebeneficiry") {
      url = getAllRechargeBeneficiaryList;
    } else if (type === "manageuser") {
      url = getManageUserList;
    } else if (type === "rakprofile") {
      url = getProfilesList;
    } else if (type === "raktransaction") {
      url = getRakTransactionList;
    } else if (type === "rakrechargetransaction") {
      url = getRechargeTransactionList;
    } else if (type === "ReferrerCode") {
      url = getReferrerCodeList;
    } else if (type === "audittrail") {
      url = getAuditTrailList;
    } else if (type === "blocklist") {
      url = getBlockList;
    }

    url(req)
      .then((res) => {
        console.log("DATA", res && res.data);

        if (
          type === "alluser" ||
          type === "registration" ||
          type === "update" ||
          type === "rejected"
        ) {
          if (res && res.data && res.data.users.length > 0) {
            let data = res.data.users.map((element) => {
              if (element.registrationDate) {
                element.registrationDate = moment(
                  element.registrationDate
                ).format("DD-MM-YYYY");
              }
              if (element.rejectedDate) {
                element.rejectedDate = moment(element.rejectedDate).format(
                  "DD-MM-YYYY"
                );
              } else {
                element.rejectedDate = "N/A";
              }
              if (element.updatedDate) {
                element.updatedDate = moment(element.updatedDate).format(
                  "DD-MM-YYYY"
                );
              } else {
                element.updatedDate = "N/A";
              }
              return element;
            });
            setdata(() => data);
            console.log(data);
          } else {
            openNotificationWithIcon(
              notificationStrings.warning,
              "No Record Found"
            );
          }
        } else if (type === "rakbeneficiary" || type === "rechargebeneficiry") {
          if (res && res.data && res.data.beneficiaries.length > 0) {
            let data = res.data.beneficiaries.map((element) => {
              if (element.registrationDate) {
                element.registrationDate = moment(
                  element.registrationDate
                ).format("DD-MM-YYYY");
              }
              return element;
            });
            setdata(() => data);
            console.log(data);
          }
        } else if (type === "manageuser") {
          if (res && res.data && res.data.users.length > 0) {
            let data = res.data.users.map((element) => {
              if (element.createdDate) {
                // console.log("createdDate",moment(element.createdDate).format('DD-MM-YYYY'))
                element.createdDate = moment(element.createdDate).format(
                  "DD-MM-YYYY"
                );
                if (element.role) {
                  element.role = element.role.name;
                }
              }
              return element;
            });
            console.log("MangeUserData", data);
            setdata(() => data);
          }
        } else if (type === "ReferrerCode") {
          if (res && res.data && res.data.users.length > 0) {
            setdata(res.data.users);
          }
        } else if (type === "rakprofile") {
          if (res && res.data && res.data.rakProfiles.length > 0) {
            let data = res.data.rakProfiles.map((element) => {
              if (element.createdDate) {
                // console.log("createdDate",moment(element.createdDate).format('DD-MM-YYYY'))
                element.date = moment(element.date).format("DD-MM-YYYY");
              }
              return element;
            });
            console.log("raktransaction", data);
            setdata(() => data);
          }
        } else if (type === "raktransaction") {
          if (
            res &&
            res.data &&
            res.data.moneyTransferTransactions.length > 0
          ) {
            let data = res.data.moneyTransferTransactions.map((element) => {
              if (element.createdDate) {
                // console.log("createdDate",moment(element.createdDate).format('DD-MM-YYYY'))
                element.createdDate = moment(element.createdDate).format(
                  "DD-MM-YYYY"
                );
              }
              return element;
            });
            console.log("raktransaction", data);
            setdata(() => data);
          }
        } else if (type === "rakrechargetransaction") {
          if (res && res.data && res.data.rechargeTransactions.length > 0) {
            let data = res.data.rechargeTransactions.map((element) => {
              if (element.createdDate) {
                // console.log("createdDate",moment(element.createdDate).format('DD-MM-YYYY'))
                element.createdDate = moment(element.createdDate).format(
                  "DD-MM-YYYY"
                );
              }
              return element;
            });
            console.log("raktransaction", data);
            setdata(() => data);
          }
        } else if (type === "audittrail") {
          if (res && res.data && res.data.auditTrails.length > 0) {
            let data = res.data.auditTrails.map((element) => {
              if (element.date) {
                // console.log("createdDate",moment(element.createdDate).format('DD-MM-YYYY'))
                element.date = moment(element.date).format("DD-MM-YYYY");
              }
              return element;
            });
            console.log("AuditTrail", data);
            setdata(() => data);
          }
        } else if (type === "blocklist") {
          if (res && res.data && res.data.blackLists.length > 0) {
            let data = res.data.blackLists.map((element) => {
              if (element.date) {
                // console.log("createdDate",moment(element.createdDate).format('DD-MM-YYYY'))
                element.createdDate = moment(element.createdDate).format(
                  "DD-MM-YYYY"
                );
              }
              return element;
            });
            console.log("AuditTrail", data);
            setdata(() => data);
          }
        }
        setCsvLoading(false);
      })
      .catch((err) => {
        setdata([]);
      });
  };

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      {csvLoading ? (
        <div
          style={{
            textAlign: "center",
          }}
        >
          <Loading color="#FFFFFF" width="25px" height="25px" />
        </div>
      ) : (
        <img
          alt="..."
          style={{ width: "40px", height: "43.5px" }}
          src={require("assets/img/icons/common/csv.png")}
          onClick={() => fetchData()}
        />
      )}
      <CSVLink
        headers={headers}
        data={data}
        filename={filename + ".csv"}
        className="hidden"
        ref={csvLink}
        target="_blank"
      />
    </div>
  );
};

export default MyCsvLink;
